import React, { Component } from "react";
import { Container, Navbar, Tabs, Spinner, Form, Badge } from "react-bootstrap";
import { Nav } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import InventoryDetailsViewer from "./InventoryDetailsViewer";

import { openModal, closeModal } from "../../../store/actions/ModalActions";
import { v4 as uuidv4 } from "uuid";

import {
  GetInventoryDetailsArea,
  GetInventoryDetailsCluster,
  GetInventoryDetailsOverall,
  GetInventoryDetailsBranch,
  GetInventoryDetailsBranchConcurrentRequest,
} from "../../../store/actions/reports/inventory_details_service_actions";

import {
  GetInventoryDetailsArea_v3,
  GetInventoryDetailsCluster_v3,
  GetInventoryDetailsOverall_v3,
  GetInventoryDetailsBranch_v3,
} from "../../../store/actions/reports-v3/inventory_details_service_actions";

import {
  GetInventoryDetailsArea_v4,
  GetInventoryDetailsCluster_v4,
  GetInventoryDetailsOverall_v4,
  GetInventoryDetailsBranch_v4,
} from "../../../store/actions/reports-v4/inventory_details_service_actions";

import {
  GetPeppHierarchy,
  GetClusters,
} from "../../../store/actions/crdm_service_actions";

import { connect } from "react-redux";
import InventoryDetailsViewFilter from "./InventoryDetailsViewFilter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faPlus,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { toastr } from "react-redux-toastr";
import moment from "moment";
import NoTabItem from "../../../components/extensions/ErrorPageDefaults/NoTabItem";
import { Link } from "react-router-dom";

const createTab = (uuid, name, searchBy, list, covered_date, filename) => {
  return { uuid, name, searchBy, list, covered_date, filename };
};
const currentDate = new Date(new Date().setDate(new Date().getDate() - 1));

class InventoryDetailsViewLayout extends Component {
  state = {
    isLoading: false,
    covered_date: currentDate,
    tabItems: [],
    lastAdded: null,
  };

  removeTab = (data) => {
    let { tabItems } = this.state;
    const index = tabItems.indexOf(data);
    tabItems.splice(index, 1);
    this.setState({ tabItems });
  };

  addView = (title, searchBy, list, covered_date, filename) => {
    let { tabItems } = this.state;

    tabItems.push(
      createTab(uuidv4(), title, searchBy, list, covered_date, filename)
    );

    this.setState({ tabItems, lastAdded: tabItems.length - 1 });
  };

  // componentDidMount() {
  //   this.setState({ isLoading: true });
  //   this._getOverallBreakdown(
  //     moment(this.state.covered_date).format("MMMM DD YYYY")
  //   ).then(() => {
  //     this.setState({ isLoading: false });
  //   });
  // }

  renderTimeOutError = () => {
    setTimeout(() => {
      openModal({
        title: "Request Timed Out",
        size: "lg",
        currentComponent: (
          <div>
            <p>
              The request has timed out. Please try generating the report again.
            </p>

            <Button className="float-right mt-3" onClick={closeModal}>
              Ok
            </Button>
          </div>
        ),
      });
    }, 100);
  };

  _getClusterBreakdown = async (clusterIds, covered_date) => {
    let requestList = [];
    let _clusterIds = clusterIds;

    _clusterIds.forEach((cluster_id) => {
      this.setState({ isLoading: true });

      requestList.push(
        this.premisefetchInventoryDetailsByClusterV4({
          covered_date: covered_date,
          clusterId: cluster_id,
        }).then((areaList) => {
          if (areaList.problem === null) {
            this.addView(
              `Cluster ${cluster_id}`,
              "Area",
              areaList.data,
              moment(covered_date).format("MMMM DD, YYYY"),
              `Inventory Details ${moment(covered_date).format("MM.DD.YYYY")}`
            );
            this.setState({ isLoading: false });
            return areaList.data;
          } else {
            this.renderTimeOutError();
          }
        })
      );
    });
    await Promise.all(requestList);
    return await Promise.resolve();
  };

  _getAreaBreakdown = async (areaIds, covered_date) => {
    let requestList = [];
    let _areaIds = areaIds;

    _areaIds.forEach((area_id) => {
      this.setState({ isLoading: true });
      requestList.push(
        this.premisefetchInventoryDetailsByAreaV4({
          covered_date: covered_date,
          area_code: area_id,
        }).then((branchList) => {
          if (branchList.problem === null) {
            this.addView(
              `Area ${area_id}`,
              "Branch",
              branchList.data,
              moment(covered_date).format("MMMM DD, YYYY"),
              `Inventory Details ${moment(covered_date).format("MM.DD.YYYY")}`
            );
            this.setState({ isLoading: false });
            return branchList.data;
          } else {
            this.renderTimeOutError();
          }
        })
      );
    });
    await Promise.all(requestList);
    return await Promise.resolve();
  };

  _getAreaBreakdownOptimized = async (areas, covered_date) => {
    let requestList = [];
    this.setState({ isLoading: true });
    areas.forEach((data) => {
      const chunkSize = 5;
      const branchCodechunks = [];

      for (let i = 0; i < data.branchCodes.length; i += chunkSize) {
        const chunk = data.branchCodes.slice(i, i + chunkSize);
        branchCodechunks.push(chunk);
      }
      requestList.push(
        this.premisefetchInventoryDetailsByBranchConcurrentRequest({
          covered_date: covered_date,
          branchCodechunks,
        }).then((responseList) => {
          if (!responseList.find((response) => response.problem !== null)) {
            const branchList = responseList.flatMap(
              (response) => response.data
            );
            this.addView(
              `Area ${data.area_code}`,
              "Branch",
              branchList,
              moment(covered_date).format("MMMM DD, YYYY"),
              `Inventory Details ${moment(covered_date).format("MM.DD.YYYY")}`
            );

            this.setState({ isLoading: false });

            return branchList;
          } else {
            this.renderTimeOutError();
          }
        })
      );
    });
    await Promise.all(requestList);
    return await Promise.resolve();
  };

  _getOverallBreakdown = async (covered_date = null) => {
    return await this.premisefetchGetInventoryDetailsOverallV4({
      covered_date: covered_date ? covered_date : this.state.covered_date,
    }).then((clusterList) => {
      if (clusterList.problem === null) {
        this.addView(
          "All",
          "All",
          clusterList.data,

          moment(covered_date ? covered_date : this.state.covered_date).format(
            "MMMM DD, YYYY"
          ),
          `Inventory Details ${moment(covered_date).format("MM.DD.YYYY")}`
        );
      } else {
        this.renderTimeOutError();
      }
    });
  };

  _getBranchBreakdown = async (branch_codes, covered_date) => {
    this.setState({ isLoading: true });
    return await this.premisefetchInventoryDetailsByBranchV4({
      covered_date: covered_date,
      branch_codes: branch_codes,
    }).then((branchList) => {
      if (branchList.problem === null) {
        this.addView(
          `Branch ${branch_codes}`,
          "Branch",
          branchList.data,
          moment(covered_date).format("MMMM DD, YYYY"),
          `Inventory Details ${moment(covered_date).format("MM.DD.YYYY")}`
        );
        this.setState({ isLoading: false });
      } else {
        this.renderTimeOutError();
      }
    });
  };

  render() {
    return (
      <Container
        className="bg-light p-2 rounded shadow-sm"
        fluid
        style={{ minHeight: 500 }}
      >
        <Navbar className="rounded">
          <Navbar.Brand>
            <Link className="mr-2" to="/pawnshop-reports/reports">
              <Button variant="outline-secondary">
                <FontAwesomeIcon icon={faArrowLeft} />
              </Button>
            </Link>
            Inventory Details
          </Navbar.Brand>
          <Navbar.Collapse>
            <Nav className="mr-auto" />
          </Navbar.Collapse>
          <Form inline>
            <Button
              size="md"
              variant="success"
              onClick={() => {
                openModal({
                  title: "New Inventory Detail Report",
                  size: "lg",
                  currentComponent: (
                    <InventoryDetailsViewFilter
                      getByOverall={this._getOverallBreakdown}
                      getByBranch={this._getBranchBreakdown}
                      getByArea={this._getAreaBreakdown}
                      getByAreaOptimized={this._getAreaBreakdownOptimized}
                      getByCluster={this._getClusterBreakdown}
                      getByOverallDateRange={this._getOverallBreakdownDateRange}
                      getByBranchDateRange={this._getBranchBreakdownDateRange}
                      getByAreaDateRange={this._getAreaBreakdownDateRange}
                      getByClusterDateRange={this._getClusterBreakdownDateRange}
                    />
                  ),
                });
              }}
            >
              <FontAwesomeIcon icon={faPlus} className="mr-1" />
              New Inventory Detail Report
            </Button>
          </Form>
        </Navbar>

        {this.state.tabItems.length > 0 ? (
          <Tabs
            className="mt-2"
            activeKey={this.state.lastAdded}
            onSelect={(idx) => this.setState({ lastAdded: idx })}
          >
            {this.state.tabItems.map((data, idx) => {
              return (
                <Tab
                  key={idx}
                  className="bg-white"
                  eventKey={idx}
                  title={
                    <div>
                      <Spinner
                        className="mr-2"
                        animation="border"
                        size="sm"
                        hidden={!this.state.isLoading}
                      />
                      {`${data.name}`}
                      <Badge className="ml-2 p-2" variant="light">
                        {data.covered_date}
                      </Badge>
                      <Button
                        className="ml-3"
                        size="sm"
                        variant="light"
                        onClick={() => {
                          toastr.confirm(
                            "Are you sure you want to close this tab?",
                            {
                              onOk: () => this.removeTab(data),
                              okText: "Yes, close it",
                            }
                          );
                        }}
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </Button>
                    </div>
                  }
                >
                  <InventoryDetailsViewer data={data} tabIndex={idx} />
                </Tab>
              );
            })}
          </Tabs>
        ) : (
          <>
            <NoTabItem appendText="New Inventory Detail Report" />
          </>
        )}
      </Container>
    );
  }

  premiseGetClusters = () => {
    return this.props.GetClusters();
  };

  premisefetchGetInventoryDetailsOverall = (data) => {
    return this.props.GetInventoryDetailsOverall({
      covered_date: data.covered_date,
    });
  };

  premisefetchInventoryDetailsByCluster = (data) => {
    return this.props.GetInventoryDetailsCluster({
      covered_date: data.covered_date,
      clusterId: data.clusterId,
    });
  };

  premisefetchInventoryDetailsByArea = (data) => {
    return this.props.GetInventoryDetailsArea({
      covered_date: data.covered_date,
      area_code: data.area_code,
    });
  };

  premisefetchInventoryDetailsByBranchConcurrentRequest = (data) => {
    return this.props.GetInventoryDetailsBranchConcurrentRequest({
      covered_date: data.covered_date,
      branchCodechunks: data.branchCodechunks,
    });
  };

  premisefetchInventoryDetailsByBranch = (data) => {
    return this.props.GetInventoryDetailsBranch({
      covered_date: data.covered_date,
      branch_codes: data.branch_codes,
    });
  };

  premisefetchGetInventoryDetailsOverallV3 = (data) => {
    return this.props.GetInventoryDetailsOverall_v3({
      dates: {
        from: data.from,
        to: data.to,
      },
    });
  };

  premisefetchInventoryDetailsByClusterV3 = (data) => {
    return this.props.GetInventoryDetailsCluster_v3({
      dates: {
        from: data.from,
        to: data.to,
      },
      clusterId: data.clusterId,
    });
  };

  premisefetchInventoryDetailsByAreaV3 = (data) => {
    return this.props.GetInventoryDetailsArea_v3({
      dates: {
        from: data.from,
        to: data.to,
      },
      area_code: data.area_code,
    });
  };

  premisefetchInventoryDetailsByBranchV3 = (data) => {
    return this.props.GetInventoryDetailsBranch_v3({
      dates: {
        from: data.from,
        to: data.to,
      },
      branch_codes: data.branch_codes,
    });
  };

  premisefetchGetInventoryDetailsOverallV4 = (data) => {
    return this.props.GetInventoryDetailsOverall_v4({
      covered_date: data.covered_date,
      isRange: data.isRange,
    });
  };

  premisefetchInventoryDetailsByClusterV4 = (data) => {
    return this.props.GetInventoryDetailsCluster_v4({
      covered_date: data.covered_date,
      clusterId: data.clusterId,
    });
  };

  premisefetchInventoryDetailsByAreaV4 = (data) => {
    return this.props.GetInventoryDetailsArea_v4({
      covered_date: data.covered_date,
      area_code: data.area_code,
    });
  };

  premisefetchInventoryDetailsByBranchV4 = (data) => {
    return this.props.GetInventoryDetailsBranch_v4({
      covered_date: data.covered_date,
      branch_codes: data.branch_codes,
    });
  };
}

const mapStateToProps = (state) => {
  return {
    clusters: state.crdm.cluster,
    areas: state.crdm.area,
  };
};

const mapDispatchToProps = {
  GetPeppHierarchy: GetPeppHierarchy,
  GetClusters: GetClusters,

  GetInventoryDetailsArea: GetInventoryDetailsArea,
  GetInventoryDetailsCluster: GetInventoryDetailsCluster,
  GetInventoryDetailsOverall: GetInventoryDetailsOverall,
  GetInventoryDetailsBranch: GetInventoryDetailsBranch,
  GetInventoryDetailsBranchConcurrentRequest:
    GetInventoryDetailsBranchConcurrentRequest,

  GetInventoryDetailsArea_v3: GetInventoryDetailsArea_v3,
  GetInventoryDetailsCluster_v3: GetInventoryDetailsCluster_v3,
  GetInventoryDetailsOverall_v3: GetInventoryDetailsOverall_v3,
  GetInventoryDetailsBranch_v3: GetInventoryDetailsBranch_v3,

  GetInventoryDetailsArea_v4: GetInventoryDetailsArea_v4,
  GetInventoryDetailsCluster_v4: GetInventoryDetailsCluster_v4,
  GetInventoryDetailsOverall_v4: GetInventoryDetailsOverall_v4,
  GetInventoryDetailsBranch_v4: GetInventoryDetailsBranch_v4,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryDetailsViewLayout);
